<template>
  <PageWrapper title="子级详情页">
    <div> 子级详情页内容在此 </div>
  </PageWrapper>
</template>
<script lang="ts">
  import { defineComponent } from 'vue';
  import { PageWrapper } from '/@/components/Page';
  export default defineComponent({ components: { PageWrapper } });
</script>
